import { render, staticRenderFns } from "./MateriDetail.vue?vue&type=template&id=08c5d7d7&scoped=true"
import script from "./MateriDetail.vue?vue&type=script&lang=js"
export * from "./MateriDetail.vue?vue&type=script&lang=js"
import style0 from "./MateriDetail.vue?vue&type=style&index=0&id=08c5d7d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5d7d7",
  null
  
)

export default component.exports